import * as React from 'react';
import * as ReqType from '../../types/ServerRequests';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { CourseForm } from './internalComponents/CourseForm';
import { LoaderButton } from '../genericComponents/Button/LoaderButton';
import { CoursService } from '../../services/CoursService';
import { AdresseService } from '../../services/AdresseService';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    match: {
        /**
         * path: le schemin
         */
        path: string,
        /**
         * url: url
         */
        url: string,
        /**
         * isExact: boolean
         */
        isExact: boolean,
        /**
         * name: string
         */
        params: {
            name: string
        }
    };
}

/**
 * interface State (l'état interne de la classe listCourses)
 */
interface State {
    disabled: boolean;
    cours: ReqType.Course | undefined;
}

/**
 * l'affichage d' un cours en particulier
 */
export class ShowCoursePage extends React.Component {
    /** le props: l'etat externe */
    props: Props;
    /** le state: l'etat interne */
    state: State;

    /** le state: backupCours du cours */
    backupCours?: ReqType.Course;

    /**
     * construit la Page Show Course
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            disabled: true,
            cours: undefined,
        };
        this.getCours();
        this.backupCours = undefined;
    }

    /**
     * le rendu de la classe ShowCoursePage
     * @returns {JSX.element}
     */
    render() {
        var form: JSX.Element = <div />;
        if (this.state.cours !== undefined) {
            form = (
                <CourseForm
                    disabled={this.state.disabled}
                    course={this.state.cours}
                    setCourse={
                        this.setCours
                    }
                />
            );
        }
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                ]}
            >
                <div>
                    {form}
                    <button
                        className="btn"
                        onClick={this.switchEditable}
                        style={!this.state.disabled ? { display: 'none' } : {marginLeft: '1cm', width: '3cm'}}
                    >
                        Modifier
                    </button>
                    <div className="row" style={{marginBottom: '20px'}}>
                        <button
                            className="btn btn-outline-danger"
                            onClick={this.switchEditable}
                            style={this.state.disabled ? { display: 'none' } : {marginLeft: '1cm', width: '3cm'}}
                        >
                            Annuler
                        </button>
                        <LoaderButton
                            className="btn"
                            onClick={() => Promise.resolve(this.submit())}
                            style={this.state.disabled ? { display: 'none' } : {marginLeft: '20px', width: '3cm'}}
                        >
                            Valider
                        </LoaderButton>
                    </div>
                </div>
            </PageChorinitia>
        );
    }

    /**
     * Permet de modifier un cours
     * @param {Course} course
     */
    private setCours = (course: ReqType.Course) => {
        this.setState({ cours: course });
    }

    /**
     * Recupère un cours depuis le backend
     */
    private getCours(): void {
        CoursService.getInstance().getCours(Number.parseInt(this.props.match.params.name)
        ).then(
            (response: ReqType.Course) => {
                response.adresse = AdresseService.getInstance().getDefaultAdresse();
                this.setState({ cours: response });
            }
        );
    }

    /**
     * Rendre le formulaire editable ou non
     */
    private switchEditable = () => {
        if (this.state.disabled && this.state.cours !== undefined) {
            this.backupCours = JSON.parse(JSON.stringify(this.state.cours));
            this.setState({ disabled: false });
        } else {
            this.setState({ disabled: true, cours: this.backupCours });
        }
    }

    /**
     * valide la modification ou crée un nouveau
     */
    private submit = () => {
        if (this.state.cours !== undefined) {
            /*var token = LoginServices.getInstance().getUserToken();
            Axios.post(
                process.env.REACT_APP_ADRESSE_ADD_URL!,
                this.state.cours.adresse,
                {
                    headers: { 'X-Access-Token': token },
                }
            ).then(
                (r: AxiosResponse<{ id: number }>) => {
                    return (Axios.put(
                        process.env.REACT_APP_COURSE_UPDATE_URL! + '&id=' + this.props.match.params.name,
                        {
                            adresse_id: r.data.id,
                            details: this.state.cours!.details,
                            discipline_id: this.state.cours!.discipline!.id,
                            jour: this.state.cours!.jour,
                            niveau_id: this.state.cours!.niveau!.id,
                        },
                        {
                            headers: { 'X-Access-Token': token },
                        }
                    ));
                }*/
            if (this.backupCours !== undefined) {
                CoursService.getInstance().updateCours(this.state.cours, this.backupCours
                ).then(
                    e => {
                        this.setState({ disabled: true });
                    }
                ).catch(
                    e => alert(JSON.stringify(e))
                );
            } else {
                CoursService.getInstance().createCours(this.state.cours
                ).then(
                    e => {
                        this.setState({ disabled: true });
                    }
                ).catch(
                    e => alert(JSON.stringify(e))
                );
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/CoursesPage/ShowCoursePage.tsx